import { useTheme } from '@emotion/react'
import { Container } from '@mui/material'
import React from 'react'
import { P, SectionWrapper } from '../../Styles/style'

const Section9_Footer = () => {

    const theme = useTheme()
    return (
        <SectionWrapper p="0rem 0">
            <Container maxWidth="xl">
                <P p="10px 0" align="center" m="0">© 2023 Richard Heart Parody on the Pulse Network. All rights reserved.</P>
            </Container>
        </SectionWrapper>
    )
}

export default Section9_Footer